import { render, staticRenderFns } from "./WarnCardList.vue?vue&type=template&id=fd4f3452&scoped=true"
import script from "./WarnCardList.vue?vue&type=script&lang=js"
export * from "./WarnCardList.vue?vue&type=script&lang=js"
import style0 from "./WarnCardList.vue?vue&type=style&index=0&id=fd4f3452&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4f3452",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd4f3452')) {
      api.createRecord('fd4f3452', component.options)
    } else {
      api.reload('fd4f3452', component.options)
    }
    module.hot.accept("./WarnCardList.vue?vue&type=template&id=fd4f3452&scoped=true", function () {
      api.rerender('fd4f3452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/warnrecord/components/WarnCardList.vue"
export default component.exports